import React from 'react';
import { useNavigate } from 'react-router-dom';
import MapTilePattern from './MapTilePattern';
import { HOME_SERVICE_PRESENTATION_BY_ID } from './constants';
import type { DashboardService } from '../../../models/dashboard.model';
import styles from './yourServices.module.scss';

interface YourServicesProps {
  dashboardServices: DashboardService[];
}

const YourServices: React.FC<YourServicesProps> = ({ dashboardServices }) => {
  const navigate = useNavigate();

  const services = dashboardServices
    .map((service) => HOME_SERVICE_PRESENTATION_BY_ID[service.id])
    .filter((service): service is NonNullable<typeof service> => Boolean(service));

  return (
    <section className={styles.section} aria-labelledby="home-your-services">
      <h2 className={styles.heading} id="home-your-services">
        Your Services
      </h2>

      <ul className={styles.list}>
        {services.map((service) => (
          <li key={service.path}>
            <button type="button" className={styles.card} onClick={() => navigate(service.path)}>
              <span className={styles.tile}>
                {service.hasPattern && <MapTilePattern />}
                <span className={styles.iconRing}>
                  <img className={styles.icon} src={service.icon} alt="" aria-hidden="true" />
                  {service.subtext && <span className={styles.subtext}>{service.subtext}</span>}
                </span>
              </span>
              <span className={styles.label}>{service.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default YourServices;
